import { useCallback } from 'react';
import { Alert } from 'react-native';
import { isWeb } from 'shared/src/utils';

type MarketingType = 'SMS' | 'PUSH' | 'NIGHT_PUSH';

type ConfirmHandler = (type: MarketingType, onConfirm: () => void) => void;

export const useMarketingAlertConfirm = (): ConfirmHandler => {
  return useCallback<ConfirmHandler>((type, onConfirm) => {
    const messageMap: Record<
      MarketingType,
      { title: string; message: string }
    > = {
      SMS: {
        title: '혜택 문자 수신 거부',
        message:
          '수신을 거부하면 할인 혜택 및 이벤트 정보를 받으실 수 없어요. 그래도 거부하시겠어요?',
      },
      PUSH: {
        title: '혜택 푸시 수신 거부',
        message:
          '수신을 거부하면 할인 혜택 및 이벤트 정보를 받으실 수 없어요. 그래도 거부하시겠어요?',
      },
      NIGHT_PUSH: {
        title: '야간 푸시 수신 거부',
        message:
          '수신을 거부하면 밤에만 열리는 반짝 이벤트를 놓칠 수 있어요. 그래도 거부하시겠어요?',
      },
    };

    const { title, message } = messageMap[type];

    if (isWeb) {
      const confirmed = window.confirm(`${title}\n\n${message}`);
      if (confirmed) onConfirm();
    } else {
      Alert.alert(title, message, [
        {
          text: '취소',
          style: 'cancel',
        },
        {
          text: '확인',
          onPress: onConfirm,
        },
      ]);
    }
  }, []);
};
